
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculator/[...type]",
      function () {
        return require("private-next-pages/calculator/[...type].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculator/[...type]"])
      });
    }
  